

class Config
{
        static url = "https://elizak.edu.pl";
 
}

export default Config;